import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const rows = [{
  before: 'Improvisas desde el pánico',
  after: 'Tienes una respuesta preparada'
}, {
  before: 'Gritas y después sientes culpa',
  after: 'Actúas con calma y claridad'
}, {
  before: 'Las salidas te generan ansiedad',
  after: 'Sales con un plan concreto'
}, {
  before: 'La crisis dura horas',
  after: 'La crisis baja en minutos'
}, {
  before: 'Te enfrentas a tu hijo',
  after: 'Acompañas a tu hijo'
}, {
  before: 'El vínculo se desgasta',
  after: 'La conexión se fortalece'
}];
export function BeforeAfter() {
  return <SectionWrapper className="bg-white py-20" data-id="element-24">
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center max-w-3xl mx-auto" data-id="element-25">
        Esto es lo que cambia cuando tienes el protocolo
      </h2>

      <div className="max-w-4xl mx-auto rounded-xl overflow-hidden border border-hairline shadow-soft" data-id="element-26">
        <div className="grid grid-cols-2" data-id="element-27">
          <div className="bg-[#F0F0F0] p-4 md:p-6 text-center border-r border-hairline" data-id="element-28">
            <span className="font-sans font-bold text-ink text-lg" data-id="element-29">
              😔 SIN PROTOCOLO
            </span>
          </div>
          <div className="bg-[#E8F5E8] p-4 md:p-6 text-center" data-id="element-30">
            <span className="font-sans font-bold text-green-800 text-lg" data-id="element-31">
              😌 CON PROTOCOLO
            </span>
          </div>
        </div>

        <div className="flex flex-col" data-id="element-32">
          {rows.map((row, index) => <div key={index} className={`grid grid-cols-2 ${index % 2 === 0 ? 'bg-white' : 'bg-cream'}`} data-id="element-33">
              <div className="p-4 md:p-6 border-r border-hairline border-t flex items-center justify-center text-center" data-id="element-34">
                <span className="font-sans text-ink-mid font-medium" data-id="element-35">
                  {row.before}
                </span>
              </div>
              <div className="p-4 md:p-6 border-t border-hairline flex items-center justify-center text-center gap-2" data-id="element-36">
                <span className="text-green-500 shrink-0" data-id="element-37">✅</span>
                <span className="font-sans text-ink font-medium" data-id="element-38">
                  {row.after}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}